/**
 * @copyright 2019 @ DigiNet
 * @author TRIHAO
 * @create 11/4/2019
 * @Example
 */

import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Config from "../../../config";
import {withStyles} from "@material-ui/styles";
import InputLabel from "@material-ui/core/InputLabel";
import {TagBox, SelectBox} from "devextreme-react";
import FormControl from "@material-ui/core/FormControl";
import {FormHelperText} from "@material-ui/core";

const styles = {
    root: {
        backgroundColor: "#FFFFFF"
    }
};
class Combo extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            shrink: props.shrink,
            value: props.value,
            opened: false,
            focused: false,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value)) {
            this.setState({
                value: this.props.value
            })
        }
    }

    onFocusIn = () => {
        this.setState({
            shrink: true,
            focused: true,
        });
    };

    onFocusOut = () => {
        const {value} = this.state;
        this.setState({
            shrink: Array.isArray(value) ? value.length > 0 : !!value || this.props.shrink,
            focused: false
        });
    };

    onOpened = (e) => {
        const {onOpened} = this.props;
        if (onOpened) onOpened(e);
    };

    onClosed = (e) => {
        const {onClosed} = this.props;
        if (onClosed) onClosed(e);
    };

    onValueChanged = (e) => {
        const {onValueChanged} = this.props;
        this.setState({
            value: e.value,
            shrink: Array.isArray(e.value) ? e.value.length > 0 : !!e.value || this.props.shrink
        });
        if (onValueChanged) onValueChanged(e);
    };

    onSelectionChanged = (e) => {
        const {onSelectionChanged} = this.props;
        if (onSelectionChanged) onSelectionChanged(e);
    };

    render() {
        const {value, shrink, focused} = this.state;
        const {
            label, style, className, margin, classes, name, multiple, error, helperText,
            height, placeholder, dataSource, stylingMode, showClearButton, acceptCustomValue,
            openOnFieldClick, showDropDownButton, disabled, noDataText, displayExpr, valueExpr,
            InputLabelProps, selectProps, searchEnabled, searchExpr, searchMode, itemRender, fieldRender
        } = this.props;

        const variant = stylingMode === 'underlined' ? "standard" : (stylingMode === 'filled' ? 'filled' : 'outlined');
        const _shrink = (Array.isArray(value) ? value.length > 0 : !!value) || shrink;

        return (
            <React.Fragment>
                <FormControl
                    error={!!error && !disabled && (Array.isArray(value) ? value.length <= 0 : !value)}
                    className={className}
                    classes={{root: classes.root}}
                    variant={variant}
                    margin={margin ? margin : "dense"}
                    fullWidth={true} style={style}>
                    <InputLabel
                        className={focused ? "Mui-focused" : ""}
                        shrink={_shrink}
                        {...InputLabelProps}
                    >{label}</InputLabel>
                    {multiple ?
                        (
                            <TagBox
                                isValid={!error || disabled || (Array.isArray(value) ? value.length > 0 : value)}
                                acceptCustomValue={acceptCustomValue}
                                dataSource={dataSource}
                                disabled={disabled}
                                displayExpr={displayExpr}
                                valueExpr={valueExpr}
                                height={height}
                                name={name}
                                noDataText={noDataText ? noDataText : Config.lang("BI_Khong_co_du_lieu")}
                                placeholder={placeholder}
                                openOnFieldClick={typeof openOnFieldClick !== "undefined" ? openOnFieldClick : true}
                                searchEnabled={typeof searchEnabled !== "undefined" ? searchEnabled : true }
                                searchExpr={searchExpr}
                                searchMode={searchMode ? searchMode : "contains"}
                                showClearButton={showClearButton}
                                showDropDownButton={typeof showDropDownButton !== "undefined" ? showDropDownButton : true}
                                stylingMode={stylingMode ? stylingMode : "outlined"}
                                value={value}
                                onFocusIn={this.onFocusIn}
                                onFocusOut={this.onFocusOut}
                                onOpened={this.onOpened}
                                onClosed={this.onClosed}
                                onValueChanged={this.onValueChanged}
                                onSelectionChanged={this.onSelectionChanged}
                                itemRender={itemRender}
                                fieldRender={fieldRender}
                                {...selectProps}
                            />
                        ) : (
                            <SelectBox
                                isValid={!error || disabled || (Array.isArray(value) ? value.length > 0 : value)}
                                acceptCustomValue={acceptCustomValue}
                                dataSource={dataSource}
                                disabled={disabled}
                                displayExpr={displayExpr}
                                valueExpr={valueExpr}
                                height={height}
                                name={name}
                                noDataText={noDataText ? noDataText : Config.lang("BI_Khong_co_du_lieu")}
                                placeholder={placeholder}
                                openOnFieldClick={typeof openOnFieldClick !== "undefined" ? openOnFieldClick : true}
                                searchEnabled={typeof searchEnabled !== "undefined" ? searchEnabled : true }
                                searchExpr={searchExpr}
                                searchMode={searchMode ? searchMode : "contains"}
                                showClearButton={showClearButton}
                                showDropDownButton={typeof showDropDownButton !== "undefined" ? showDropDownButton : true}
                                stylingMode={stylingMode ? stylingMode : "outlined"}
                                value={value}
                                onFocusIn={this.onFocusIn}
                                onFocusOut={this.onFocusOut}
                                onOpened={this.onOpened}
                                onClosed={this.onClosed}
                                onValueChanged={this.onValueChanged}
                                onSelectionChanged={this.onSelectionChanged}
                                itemRender={itemRender}
                                fieldRender={fieldRender}
                                {...selectProps}
                            />
                        )}
                        <FormHelperText>{typeof error === "string" && (Array.isArray(value) ? value.length <= 0 : !value) ? error : helperText}</FormHelperText>
                </FormControl>
            </React.Fragment>
        );
    }
}

Combo.propTypes = {
    label: PropTypes.string,
    shrink: PropTypes.bool,
    style: PropTypes.any,
    className: PropTypes.string,
    height: PropTypes.any,
    margin: PropTypes.string,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    multiple: PropTypes.bool,
    error: PropTypes.any,
    helperText: PropTypes.bool,

    value: PropTypes.any,
    displayExpr: PropTypes.any,
    valueExpr: PropTypes.any,
    acceptCustomValue: PropTypes.bool,
    openOnFieldClick: PropTypes.bool,
    showDropDownButton: PropTypes.bool,
    dataSource: PropTypes.any,
    placeholder: PropTypes.string,
    stylingMode: PropTypes.string,
    showClearButton: PropTypes.bool,
    noDataText: PropTypes.string,
    searchEnabled: PropTypes.bool,
    searchExpr: PropTypes.any,
    searchMode: PropTypes.string,
    itemRender: PropTypes.any,
    fieldRender: PropTypes.any,

    InputLabelProps: PropTypes.any,
    selectProps: PropTypes.any,

    onFocusIn: PropTypes.func,
    onFocusOut: PropTypes.func,
    onOpened: PropTypes.func,
    onClosed: PropTypes.func,
    onSelectionChanged: PropTypes.func,
    onValueChanged: PropTypes.func,

};

export default withStyles(styles)(Combo);
